<template>
    <div class="main-panel">
        <top-navbar></top-navbar>
        <div class="content">
            <div class="card">
                <FlashMessage :position="'right top'"></FlashMessage>
    
                <div class="card-header">
                    <h4 class="title">Add Referral</h4>
                </div>
                <div class="card-body">
                    <form @submit.prevent="submit" >
                        <div class="row">
                            <div class="col-md-4">
                                <label>Promotion<em style="color:red">*</em></label>
                                <select class="form-control" v-model.trim="$v.referraldata.promotionid.$model">
                                    <option disabled value>Select promotion</option>
                                    <option v-for="(list, index) in promotion" :value="list.promotionid" :key="index">
                                        {{ list.promotion }}
                                    </option>
                                </select>
                                <div class="error" v-if="submitted && !$v.referraldata.promotionid.required">Please select promotion</div>
                            </div>
    
                            <div class="col-md-4">
                                <label>Referral<em style="color:red">*</em></label>
                                <input class="form-control" v-model.trim="$v.referraldata.referral.$model" type="text" label="Referral" placeholder="Enter referral" />
                                <div class="error" v-if="submitted && !$v.referraldata.referral.required">Please enter referral</div>
    
                            </div>

                            <div class="col-md-4">
                                <label>Status<em style="color:red">*</em></label>
                                <select class="form-control" v-model.trim="$v.referraldata.status.$model">
                                    <option disabled>Select status</option>
                                    <option value="1">Active</option>
                                    <option value="0">InActive</option>
                                </select>
                                <div class="error" v-if="submitted && !$v.referraldata.status.required">Please select status</div>
                            </div>
    
                        </div><br>
    
                        <div class="text">
                            <button type="submit" class="btn btn-secondary dashboard">Add Referral</button>&nbsp;
                            <router-link to="/admin/dashboard/referral"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>
    
                        </div>
    
                    </form>
                </div>
            </div>
    
        </div>
        <content-footer></content-footer>
    </div>
    </template>
    
    <script>
    import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
    import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
    import ValidationError from "src/components/UIComponents/ValidationError.vue";
    import {
        required,
        minLength,
        maxLength,
        between,
        file_size_validation,
    } from "vuelidate/lib/validators";
    import {
        exit
    } from "process";
    export default {
        name: 'addReferral',
        components: {
            TopNavbar,
            ContentFooter,
            ValidationError,
    
        },
    
        data() {
            return {
                submitted: false,
                promotion: [],
                referraldata: {
                    promotionid: '',
                    referral: '',
                    status: '1',
                }
            }
        },
    
        validations: {
            referraldata: {
                promotionid: {
                    required,
                },
                referral: {
                    required,
                },
                status: {
                    required,
                },
            }
        },
    
        methods: {
       
            submit() {   
                this.submitted = true;
                this.$v.$touch()
    
                if (this.$v.$invalid) {
                    return;
                } else {
                    this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/addreferral`, this.referraldata)
                        .then(({
                            data
                        }) => {
                            this.$router.push('/admin/dashboard/referral');
                            this.flashMessage.success({
                                message: 'Referral Added Successfully',
                            });
                        })
                    // .catch((error) => {
                    //     console.log(error);
                    // });
    
                }
            }
        },
    
        async mounted() {
            await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getactivepromotion`).then((res) => {
                this.promotion = res.data;
            });
        },
    
    };
    </script>
    
    <style lang="scss">
    </style>
    